import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '@/store/authStore';

/**
 * RoleBasedRedirect - Composant pour rediriger automatiquement vers le dashboard approprié
 * Utilisé pour les routes qui doivent rediriger selon le rôle (ex: /dashboard)
 */
const RoleBasedRedirect = () => {
  const { user, isAuthenticated } = useAuthStore();

  // Si non authentifié, rediriger vers la landing page
  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  // Rediriger vers le dashboard approprié selon le rôle
  const getDashboardRouteForRole = (role) => {
    const roleRoutes = {
      'ADMIN': '/admin/dashboard',
      'AGENT': '/admin/dashboard',
      'CLIENT': '/client/dashboard',
      'TRANSPORTEUR': '/transporter/dashboard',
    };
    return roleRoutes[role] || '/';
  };

  const dashboardRoute = getDashboardRouteForRole(user.role);
  return <Navigate to={dashboardRoute} replace />;
};

export default RoleBasedRedirect;

